/**
 * Hook para tracking de abandono de carrito y checkout.
 */

const BASE_URL = process.env.BASE_URL || '';
const TRACKING_ENABLED = process.env.GATSBY_TRACKING_ENABLED !== 'false';

function getSessionId() {
  if (typeof localStorage === 'undefined') return null;
  let sid = localStorage.getItem('_tracking_session');
  if (!sid) {
    sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('_tracking_session', sid);
  }
  return sid;
}

export function trackCartStage(stage, cartItems = [], cartTotal = 0) {
  if (!TRACKING_ENABLED || typeof window === 'undefined') return;

  const session_id = getSessionId();
  const user = (() => { try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; } })();

  const payload = JSON.stringify({
    session_id,
    stage,
    user_id: user?.id || null,
    email: user?.email || null,
    cart_total: cartTotal,
    items_count: cartItems.length,
    cart_data: cartItems.map(item => ({ id: item.product_id || item.id, name: item.name, qty: item.quantity || 1, price: item.sale_price || item.price || 0 })),
  });

  fetch(`${BASE_URL}/track/cart-stage`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch(() => {});
}

export default trackCartStage;
